export const GOOGLE_MERCHANT_CENTER_DATA_SOURCE = '/merchant/google-product-source.tsv';

export interface GoogleMerchantCenterSettings {
    enabled: boolean;
}